import { KeycloakAuthorizationInstance } from "keycloak-js/dist/keycloak-authz";
import { useKeycloak } from "../components/keycloak-provider";
import jwtDecode from "jwt-decode";
import React from "react";

export const BACKOFFICE_RESOURCE = "backoffice";
export const ACCESS_DENIED = new Error("Access Denied.");

export async function getPropertyRpt(
  property: string,
  authz: KeycloakAuthorizationInstance
): Promise<string> {
  authz.rpt = null;
  return await new Promise<string>((resolve, reject) =>
    authz
      .entitlement(BACKOFFICE_RESOURCE, {
        permissions: [
          {
            id: `property:${property}`,
          },
        ],
      })
      .then(
        rpt => resolve(rpt),
        () => reject(ACCESS_DENIED),
        () => reject(new Error("authz error"))
      )
  );
}

export interface IUserAuthInfo {
  isWitAdmin: boolean;
  isCRMReadOnly: boolean;
  isC2tAdmin: boolean;
  isCRMAdmin: boolean;
}

export function useUserAuthInfo(): IUserAuthInfo | undefined {
  const keycloak = useKeycloak();
  if (!keycloak.tokenParsed) {
    return undefined;
  }
  const roles = keycloak.tokenParsed.realm_access?.roles || [];
  
  return {
    isWitAdmin: roles.indexOf("witbooking-admin") !== -1,
    isCRMReadOnly: roles.indexOf("crm-read-only") !== -1,
    isC2tAdmin: roles.indexOf("c2t-admin") !== -1,
    isCRMAdmin: roles.indexOf("crm-admin") !== -1,
  };
}

export function withUserAuthInfo<P = {}>(
  Component: React.ComponentType<P & { userInfo: IUserAuthInfo }>
): React.ComponentType<P> {
  return (props: P) => {
    const info = useUserAuthInfo();
    return <>{info && <Component userInfo={info} {...props} />}</>;
  };
}

export function decodeRptToken(token: string): IRptToken | undefined {
  try {
    return jwtDecode(token);
  } catch (e) {
    console.error("Error decoding JWT token", e);
    return undefined;
  }
}

export function isJWTTokenExpired(token: string): boolean {
  const decoded = jwtDecode(token) as any;
  return decoded.exp * 1000 < Date.now();
}

export interface IRptToken {
  email: string;
  authorization: {
    permissions?: IPermission[];
  };
}

export interface IPermission {
  scopes: string[];
  rsid: string;
  rsname: string;
}
